import React from 'react';
import { find } from 'lodash';
import enhance from './InfluencerProfile.enhancer';
import { Grid } from '@material-ui/core';
import Typography from '@material-ui/core/Typography';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faYoutube } from '@fortawesome/free-brands-svg-icons';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import TablePagination from '@material-ui/core/TablePagination';
import ItemsCarousel from 'react-items-carousel';
import { filter, uniqBy, orderBy } from 'lodash';
import { dealStatuses, campaignStatuses } from '../../../constants';
import Fab from '@material-ui/core/Fab';
import Paper from '@material-ui/core/Paper';
import StarRatings from 'react-star-ratings';
import LinkText from '../../shared/components/LinkText';
import Button from '@material-ui/core/Button';
import SendCampaignMatchPopup from '../../shared/components/SendCampaignMatchPopup';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';

class InfluencerProfile extends React.Component {
  constructor() {
    super();
    const initialState = {
      completedDealRows: [],
      subscriberCount: '',
      videosLoaded: false,
      userProfile: {},
      completedDealsLoaded: false,
      completedDeals: [],
      completedDealsCount: 0,
      matchCount: 0,
      rating: 0,
      ratings: [],
      ratingsCount: 0,
      campaigns: [],
      activeCampaigns: [],
      products: [],
      dealsLoaded: false,
      ratingsLoaded: false,
      count: 0,
      currentPage: 0,
      currentActiveYoutubeVideo: 0,
      numberOfCards: this.currentWidth()
    };

    this.state = {
      ...initialState
    };
  }
  componentWillReceiveProps(nextProps) {
    const currentUid = this.props.userId;
    const nextuid = nextProps.userId;
    if (currentUid !== nextuid) {
      this.loadData(nextProps.userId);
    }
  }

  componentDidMount() {
    this.loadData(this.props.userId);

    window.addEventListener(
      'resize',
      () => {
        const numberOfCards = this.currentWidth();
        if (this.state.numberOfCards !== numberOfCards) {
          this.setState({
            numberOfCards
          });
        }
      },
      false
    );
  }

  loadData(userId) {
    // get userProfile from userId
    this.props.firestore
      .get({
        collection: 'users',
        doc: userId
      })
      .then(user => {
        const userData = user.data();
        if (userData) {
          this.setState({
            userProfile: {
              ...userData,
              id: user.id
            },
            products: userData.products
          });
        }
      });

    // get deals
    this.props.firestore
      .get({
        collection: 'deals',
        where: [['influencerId', '==', userId]],
        storeAs: 'profileDeals'
      })
      .then(dealSnaps => {
        if (dealSnaps.docs.length) {
          const deals = dealSnaps.docs.map(deal => {
            return {
              ...deal.data(),
              id: deal.id
            };
          });

          const completedDeals = filter(
            deals,
            deal => deal.status === dealStatuses.COMPLETE
          );
          const completedDealsCount = completedDeals.length;
          const matchCount = uniqBy(deals, deal => deal.companyId).length;

          this.setState({
            ...this.state,
            deals,
            completedDeals,
            completedDealsCount,
            matchCount,
            dealsLoaded: true
          });

          this.createCompletedDealTableRows();
        }
      });

    // get ratings
    this.props.firestore
      .get({
        collection: 'ratings',
        where: [['ratedUser', '==', userId]]
      })
      .then(ratingSnaps => {
        if (ratingSnaps.docs.length) {
          const ratings = ratingSnaps.docs.map(rating => {
            return {
              ...rating.data(),
              id: rating.id
            };
          });

          let rating = 0;
          if (ratings && ratings.length) {
            let total = 0;
            ratings.forEach(rating => {
              total = total + rating.rating;
            });

            rating = total / ratings.length;
          }

          this.setState({
            ...this.state,
            ratings,
            rating,
            ratingsCount: ratings.length,
            ratingsLoaded: true
          });
        } else {
          this.setState({
            ...this.state,
            ratingsLoaded: true
          });
        }
        this.createCompletedDealTableRows();
      });
  }

  navigateToCampaign = campaignId => {
    this.props.history.push(`/campaigns/${campaignId}`);
  };

  createCompletedDealTableRows() {
    if (this.state.dealsLoaded && this.state.ratingsLoaded) {
      const completedDeals = this.state.completedDeals;
      const ratings = this.state.ratings;
      const rowPromises = completedDeals.slice(0, 5).map(deal => {
        return new Promise(resolve => {
          const date = deal.currentProposal.dueDate.toDate();
          const dueDate = `${date.getMonth()}/${date.getDate()}/${date.getFullYear()}`;

          // load campaign from firestore
          this.props.firestore
            .get({
              collection: 'campaigns',
              storeAs: 'influencerCampaigns',
              doc: deal.campaignId
            })
            .then(camp => {
              if (camp && deal.campaignId) {
                const campData = camp.data();
                if (campData) {
                  deal.campaignName = campData.name;
                  deal.campaignId = camp.id;
                }
              }
              const matchedRating = find(
                ratings,
                rating => rating.dealId === deal.id
              );

              resolve({
                ...deal,
                dueDateString: dueDate,
                rating: matchedRating ? matchedRating.rating : ''
              });
            });
        });
      });

      Promise.all(rowPromises).then(deals => {
        this.setState({
          ...this.state,
          completedDealRows: deals
        });
      });
    }
  }

  handleChangePage(event, newPage) {
    const rowStart = newPage * 10;
    this.setState({
      currentPage: newPage,
      tableRows: this.state.completedDeals.slice(rowStart, rowStart + 10)
    });
  }

  currentWidth() {
    let numberOfCards;

    if (window.innerWidth < 600) numberOfCards = 1;
    else if (window.innerWidth < 1100) numberOfCards = 2;
    else if (window.innerWidth < 1500) numberOfCards = 3;
    else numberOfCards = 4;

    return numberOfCards;
  }

  openSendMatchPopup = (influencerId, event) => {
    this.setState({
      ...this.state,
      campaignMatchPopupOpen: true,
      campaignMatchPopupTarget: event.target,
      influencerMatchSelection: influencerId
    });
  };

  closeSendMatchPopup() {
    this.setState({
      ...this.state,
      campaignMatchPopupOpen: false,
      campaignMatchPopupTarget: null,
      campaignSelection: null,
      influencerMatchSelection: null
    });
  }

  setActiveYoutubeVideo = value => {
    this.setState({
      ...this.state,
      currentActiveYoutubeVideo: value
    });
  };

  campaignChangeHandler(e) {
    this.setState({
      ...this.state,
      campaignSelection: e.target.value
    });
  }

  navigateToProposeDeal() {
    if (this.state.campaignSelection) {
      // check if there is a deal with this campaign and
      // TODO: THIS ISNT WORKING
      const existingActiveDeals = this.props.deals.filter(
        deal =>
          deal.campaignId === this.state.campaignSelection.id &&
          deal.influencerId === this.props.userId &&
          deal.status !== dealStatuses.COMPLETE
      );
      if (!existingActiveDeals.length) {
        this.props.navigateToDealProposal(this.state.campaignSelection);
      } else {
        this.props.showAlreadyMatchedNotification();
      }

      this.setState({
        ...this.state,
        campaignMatchPopupOpen: false,
        campaignMatchPopupTarget: null,
        campaignSelection: null,
        influencerMatchSelection: null
      });
    }
  }

  openProposeDeal = (influencer, event) => {
    if (!this.props.activeCampaigns.length) {
      this.props.showNoActiveCampaignsNotification();
    } else {
      // check if the company has multiple active campaigns - if so they have to select which one

      if (this.props.activeCampaigns.length > 1) {
        this.openSendMatchPopup(influencer, event);
      } else {
        const campaign = this.props.campaign
          ? this.props.campaign
          : this.props.activeCampaigns[0];
        this.proposeDealForCampaign(influencer, campaign);
      }
    }
  };

  render() {
    const { classes, auth, profile, campaigns } = this.props;

    const {
      completedDealRows,
      youtubeUploads,
      userProfile,
      completedDeals,
      completedDealsCount,
      matchCount,
      rating,
      ratings,
      ratingsCount,
      count,
      currentPage,
      campaignMatchPopupOpen,
      campaignMatchPopupTarget,
      campaignSelection,
      numberOfCards,
      currentActiveYoutubeVideo
    } = this.state;

    return (
      <React.Fragment>
        <main className={classes.layout}>
          <Grid container direction="column" spacing={8}>
            <Grid
              item
              container
              xs={12}
              direction="row"
              alignItems="center"
              spacing={2}
            >
              <Grid container direction="row" spacing={4}>
                <Grid item>
                  <img
                    src={userProfile.profilePictureUrl}
                    className={classes.circleImage}
                  />
                </Grid>
                <Grid
                  item
                  xs
                  container
                  direction="column"
                  justify="center"
                  spacing={2}
                >
                  <Grid item style={{ width: '100%' }}>
                    <Typography display="inline" variant="h5">
                      {userProfile.displayName}
                    </Typography>
                    {profile.isCompany && (
                      <Button
                        color="primary"
                        variant="contained"
                        className={classes.matchButton}
                        onClick={event =>
                          this.openProposeDeal(userProfile, event)
                        }
                      >
                        Propose Deal
                      </Button>
                    )}
                  </Grid>
                  <Grid item container spacing={2}>
                    <Grid item>
                      <div className={classes.profileStatsContainer}>
                        <Typography>
                          {completedDealsCount} Deals Completed
                        </Typography>
                      </div>
                    </Grid>
                    <Grid item>
                      <div className={classes.profileStatsContainer}>
                        <Typography>{matchCount} Followers</Typography>
                      </div>
                    </Grid>
                    <Grid item>
                      <div className={classes.profileStatsContainer}>
                        <div className={classes.rating}>
                          <StarRatings
                            rating={rating}
                            starRatedColor="#22c26e"
                            starDimension="1rem"
                            starSpacing={2}
                            name="rating"
                          />
                        </div>
                        <Typography> ({ratingsCount})</Typography>
                      </div>
                    </Grid>
                  </Grid>
                  <Grid className={classes.interestContainer}>
                    {userProfile &&
                      userProfile.interests &&
                      userProfile.interests
                        .slice(0, 3)
                        .map((interest, index) => (
                          <span className={classes.interest}>{interest}</span>
                        ))}
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12} container direction="row" spacing={4}>
              <Grid item>
                <Grid container direction="column">
                  <Typography className={classes.subTitle} variant="h5">
                    Social Media
                  </Typography>
                  <Grid item>
                    <Grid container direction="row" spacing={2}>
                      <Grid item>
                        <div className={classes.interestItem}>
                          <Grid
                            container
                            spacing={2}
                            direction="column"
                            alignItems="center"
                          >
                            <Grid item>
                              <Typography align="center" variant="h6">
                                Youtube
                              </Typography>
                            </Grid>
                            <Grid item>
                              <a
                                href={`https://www.youtube.com/channel/${userProfile.youtubeChannelId}`}
                                target="_blank"
                                className={classes.link}
                              >
                                <Fab color="secondary" aria-label="youtube">
                                  <FontAwesomeIcon
                                    className={`${classes.icon} ${classes.youtubeIcon}`}
                                    icon={faYoutube}
                                  />
                                </Fab>
                              </a>
                            </Grid>
                            <Grid item>
                              <Typography align="center">
                                <a
                                  href={`https://www.youtube.com/channel/${userProfile.youtubeChannelId}`}
                                  target="_blank"
                                  className={classes.link}
                                >
                                  @{userProfile.youtubeUsername}
                                </a>
                              </Typography>
                            </Grid>
                          </Grid>
                        </div>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item>
                <Grid container direction="column">
                  <Grid item>
                    <Typography className={classes.subTitle} variant="h5">
                      Statistics
                    </Typography>
                  </Grid>
                  <Grid item>
                    <Grid container direction="column" spacing={2}>
                      <Grid item>
                        <div className={classes.profileStatsContainer}>
                          <Typography>
                            {userProfile.youtube
                              ? userProfile.youtube.subscribers.toLocaleString()
                              : 0}{' '}
                            Subscribers
                          </Typography>
                        </div>
                      </Grid>
                      <Grid item>
                        <div className={classes.profileStatsContainer}>
                          <Typography>
                            {userProfile.youtube
                              ? userProfile.youtube.videoCount.toLocaleString()
                              : 0}{' '}
                            Videos
                          </Typography>
                        </div>
                      </Grid>
                      <Grid item>
                        <div className={classes.profileStatsContainer}>
                          <Typography>
                            {userProfile.youtube && userProfile.youtube.averageViews
                              ? userProfile.youtube.averageViews.toLocaleString()
                              : 0}{' '}
                            Average Views
                          </Typography>
                        </div>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
              {userProfile.youtube && userProfile.youtube.demographics && (
                <Grid item>
                  <Grid container direction="column">
                    <Typography className={classes.subTitle} variant="h5">
                      Audience
                    </Typography>
                    <Grid item className={classes.audienceContainer}>
                      {userProfile.youtube.demographics
                        .ageAndGenderDemographics &&
                        userProfile.youtube.demographics
                          .ageAndGenderDemographics.list && (
                          <div
                            className={`${classes.audienceColumnContainer} ${classes.profileStatsContainer}`}
                          >
                            <Grid container direction="row">
                              <Grid item sm={6}>
                                <Typography className={classes.audienceHeader}>
                                  Age/Gender
                                </Typography>
                              </Grid>
                              <Grid item sm={6}>
                                <Typography className={classes.audienceHeader}>
                                  Percentage
                                </Typography>
                              </Grid>
                              {orderBy(
                                userProfile.youtube.demographics
                                  .ageAndGenderDemographics.list,
                                ['percentage'],
                                ['desc']
                              ).map(ageGender => {
                                return (
                                  <React.Fragment>
                                    <Grid item sm={6}>
                                      <Typography className={classes.demoItem}>
                                        {`${ageGender.gender}s ${ageGender.lowerAgeRange}-${ageGender.higherAgeRange}`}
                                      </Typography>
                                    </Grid>
                                    <Grid item sm={6}>
                                      <Typography className={classes.demoItem}>
                                        {`${ageGender.percentage}%`}
                                      </Typography>
                                    </Grid>
                                  </React.Fragment>
                                );
                              })}
                            </Grid>
                          </div>
                        )}
                      {userProfile.youtube.demographics.countryDemographics &&
                        userProfile.youtube.demographics.countryDemographics
                          .list && (
                          <div
                            className={`${classes.audienceColumnContainer} ${classes.profileStatsContainer}`}
                          >
                            <Grid container direction="row">
                              <Grid item sm={6}>
                                <Typography className={classes.audienceHeader}>
                                  Country
                                </Typography>
                              </Grid>
                              <Grid item sm={6}>
                                <Typography className={classes.audienceHeader}>
                                  Percentage
                                </Typography>
                              </Grid>
                              {orderBy(
                                userProfile.youtube.demographics
                                  .countryDemographics.list,
                                ['percentage'],
                                ['desc']
                              )
                                .filter(c => c.percentage > 0.01)
                                .map(country => {
                                  return (
                                    <React.Fragment>
                                      <Grid item sm={6}>
                                        <Typography
                                          className={classes.demoItem}
                                        >
                                          {`${country.countryName}`}
                                        </Typography>
                                      </Grid>
                                      <Grid item sm={6}>
                                        <Typography
                                          className={classes.demoItem}
                                        >
                                          {`${Math.round(
                                            country.percentage * 100
                                          )}%`}
                                        </Typography>
                                      </Grid>
                                    </React.Fragment>
                                  );
                                })}
                            </Grid>
                          </div>
                        )}
                    </Grid>
                  </Grid>
                </Grid>
              )}
            </Grid>
            <Grid item xs={12}>
              <Typography variant="h5" className={classes.subTitle}>
                About
              </Typography>
              <div className={classes.profileStatsContainer}>
                <Typography>{userProfile.description}</Typography>
              </div>
            </Grid>
            <Grid item xs={12}>
              <Typography variant="h5" className={classes.subTitle}>
                Latest Content
              </Typography>
              <div style={{ width: '95%' }}>
                {userProfile.youtube &&
                  userProfile.youtube.last5Uploads &&
                  userProfile.youtube.last5Uploads.length && (
                    <ItemsCarousel
                      gutter={12}
                      activePosition={'center'}
                      chevronWidth={40}
                      numberOfCards={numberOfCards}
                      outsideChevron={true}
                      showSlither={false}
                      firstAndLastGutter={false}
                      activeItemIndex={currentActiveYoutubeVideo}
                      requestToChangeActive={this.setActiveYoutubeVideo.bind(
                        this
                      )}
                      rightChevron={<ChevronRightIcon />}
                      leftChevron={<ChevronLeftIcon />}
                    >
                      {userProfile.youtube.last5Uploads.map(upload => (
                        <div
                          key={upload.contentDetails.videoId}
                          className={classes.youtubeVideoUpload}
                        >
                          <iframe
                            className={classes.iframeContainer}
                            src={`https://www.youtube.com/embed/${upload.contentDetails.videoId}`}
                            frameborder="0"
                            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                            allowfullscreen
                          />
                        </div>
                      ))}
                    </ItemsCarousel>
                  )}
              </div>
            </Grid>
            <Grid item xs={12}>
              <Typography variant="h5" className={classes.subTitle}>
                Recent Deals
              </Typography>
              <Paper className={classes.root}>
                <Table className={classes.table}>
                  <TableBody>
                    <TableRow>
                      <TableCell className={classes.headerCell}>Date</TableCell>
                      <TableCell className={classes.headerCell}>
                        Campaign Title
                      </TableCell>
                      <TableCell className={classes.headerCell}>
                        Raiting
                      </TableCell>
                    </TableRow>
                    {completedDealRows &&
                      completedDealRows.length > 0 &&
                      completedDealRows.map((row, i) => (
                        <TableRow key={i} className={classes.tableRow}>
                          <TableCell
                            component="th"
                            scope="row"
                            className={classes.tableCell}
                          >
                            {row.dueDateString}
                          </TableCell>
                          <TableCell
                            component="th"
                            scope="row"
                            className={classes.tableCell}
                          >
                            <LinkText
                              className={classes.camapignLink}
                              onClick={() =>
                                this.navigateToCampaign(row.campaignId)
                              }
                            >
                              {row.campaignName}
                            </LinkText>
                          </TableCell>
                          <TableCell
                            component="th"
                            scope="row"
                            className={classes.tableCell}
                          >
                            <StarRatings
                              rating={Number(row.rating)}
                              starRatedColor="#22c26e"
                              starDimension="1.25rem"
                              starSpacing={2}
                              name="rating"
                            />
                          </TableCell>
                        </TableRow>
                      ))}
                    {(!completedDealRows || completedDealRows.length <= 0) && (
                      <TableRow>
                        <TableCell colSpan={5}>
                          <Typography align="center" variant="h6">
                            No Completed Deals
                          </Typography>
                        </TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
                <TablePagination
                  component="div"
                  count={count}
                  rowsPerPage={10}
                  page={currentPage}
                  backIconButtonProps={{
                    'aria-label': 'Previous Page'
                  }}
                  nextIconButtonProps={{
                    'aria-label': 'Next Page'
                  }}
                  onChangePage={this.handleChangePage.bind(this)}
                />
              </Paper>
            </Grid>
          </Grid>
        </main>
        <SendCampaignMatchPopup
          open={campaignMatchPopupOpen}
          campaignMatchPopupTarget={campaignMatchPopupTarget}
          onClose={this.closeSendMatchPopup.bind(this)}
          campaigns={campaigns}
          campaignChangeHandler={this.campaignChangeHandler.bind(this)}
          campaignSelection={campaignSelection}
          selectCampaignForProposal={this.navigateToProposeDeal.bind(this)}
        />
      </React.Fragment>
    );
  }
}

export default enhance(InfluencerProfile);



// WEBPACK FOOTER //
// ./src/components/influencer/profile/InfluencerProfile.js